<template>
  <div>
    <div
      v-for="index in 7"
      v-visible="index <= maxValue"
      :class="index < value.min || index > value.max ? 'inactive' : 'active'"
    >
      {{ index }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'indicator-boxes',
  props: {
    value: {},
    maxValue: { default: 7 },
  },
}
</script>
<style lang="scss" scoped>
.legend,
.editedLegend {
  position: relative;
  width: 97%;
  height: 100px;
  display: flex;
  justify-content: space-around;
  padding: 0px 1.5%;
}
</style>
